import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import {
  COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES,
  coursePauseRequestedRequestUpdateModalSelector,
  selectedRequestSelector,
  setCoursePauseRequestedRequestUpdateModalStage,
  useUpdateRequestedRequestMutation,
} from 'features/courseResume';

function CancelRequestButton() {
  const dispatch = useDispatch();
  const { coursePauseRequestedDuration, coursePauseRequestedStreakEnabled } =
    useSelector(coursePauseRequestedRequestUpdateModalSelector);

  const [
    updateRequestedRequest,
    { isSuccess: isUpdatedSuccessfully, error, isLoading: isUpdating },
  ] = useUpdateRequestedRequestMutation();
  const selectedRequest = useSelector(selectedRequestSelector);

  useEffect(() => {
    if (isUpdatedSuccessfully) {
      dispatch(
        setCoursePauseRequestedRequestUpdateModalStage(
          COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.success
        )
      );
    }
  }, [dispatch, isUpdatedSuccessfully]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in carrying out this action. Please try again later!'
      );
    }
  }, [error]);

  const handleUpdate = useCallback(() => {
    if (isUpdating) return;

    updateRequestedRequest({
      requestId: selectedRequest.id,
      duration: coursePauseRequestedDuration.value,
      streakEnabled: coursePauseRequestedStreakEnabled,
    });
  }, [
    selectedRequest,
    updateRequestedRequest,
    isUpdating,
    coursePauseRequestedDuration,
    coursePauseRequestedStreakEnabled,
  ]);

  return (
    <Tappable
      disabled={isUpdating}
      onClick={handleUpdate}
      className="btn btn-primary btn-small m-l-10"
    >
      Submit Request
    </Tappable>
  );
}

export default CancelRequestButton;
